<template>
  <v-row>
    <v-col>
      <deposit-table
        :loading="loading"
        :items="points"
        @create="newPoint"
        @edit="editItem"
        @move="moveItem"
        @remove="remove"
      />
      <input-block :modules="inputs" :title="null" />
    </v-col>
    <v-col>
      <props
        v-if="activeItem"
        :data="activeItem"
        @update="update"
      />
      <p v-else>Выберите проект для редактирования или создайте новый</p>
    </v-col>
    <snackbar v-bind.sync="snackbar" />
  </v-row>
</template>

<script>
import transport from "../../mixins/transport";
import Snackbar from "../Snackbar";
import Props from "./Props";
import InputBlock from "../InputBlock/InputBlock";
import DepositTable from "./DepositTable";

export default {
  name: "AboutDepositPage",
  components: {DepositTable, Snackbar, Props, InputBlock },
  mixins: [transport],
  data() {
    return {
      points: [],
      activeItem: null,
      emptyPoint: {
        title_ru: null,
        title_kk: null,
        title_en: null,
        text_ru: null,
        text_kk: null,
        text_en: null,
        sort: null,
      },
      deleteDialog: false,
      deleteItem: null,
      inputs: {
        about: {
          depositPointsMedian: {
            type: "integer",
            langs: ["all"],
            prepend: "mdi-sort-numeric-variant",
            label: "Изображение после (моб.)",
            hint: "В моб. версии изображение располагается посередине списка. Укажите, после какого пункта его поставить",
            extendRules: [
              v=> (isNaN(v) && !v) || v === null || v >= 0 || "Должно быть ≥ 0"
            ]
          },
          technologyDescription:{
            type: "image",
            langs: ["ru", "kk", "en"],
            label: "Схема технологии",
            hint: "775×673 или SVG (предпочтительнее)",
            prepend: "lang",
          },
        }
      },
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.exchange(
        (points) => {
          this.points = points;
        },
        {},
        "about/list"
      );
    },
    newPoint() {
      this.activeItem = this.emptyPoint;
    },
    editItem(point) {
      this.activeItem = point;
    },
    update(data) {
      this.exchange(
        (response) => {
          this.points = response.list;
          this.activeItem = response.activeItem;
        },
        data,
        "about/list",
        "post",
        null,
        "сохранено"
      );
    },
    remove(point) {
      this.exchange(
        (data) => {
          this.points = data;
        },
        null,
        "about/list/remove/" + point.id,
        "post",
        null,
        () => {
          this.warningSnack("Удалено");
        }
      );
    },
    moveItem(item, dir) {
      this.exchange(
        (data) => {
          this.points = data;
        },
        {},
        "about/list/move/" + item.id + "/" + dir,
        "post"
      );
    }
  }
};
</script>
